import { QueryListsSizesReturnValue, useQueryListsSizes } from 'modules/campaigns/editor/hooks';
import { AudienceList } from 'modules/domains/campaign';
import { useMemo } from 'react';

export const CALCULATE_SELECTED_LISTS_SIZE_DEFAULT_STATE: CalculateSelectedListsSizesState = {
  isLoading: false,
  totalRecipients: undefined,
  selectedListsSizesById: {},
};

export type CalculateSelectedListsSizesState = {
  isLoading: boolean;
  totalRecipients: number | undefined;
  selectedListsSizesById: Record<number, QueryListsSizesReturnValue>;
};

type SelectedListsSizesById = { [key: number]: QueryListsSizesReturnValue };

export const useCalculateSelectedListsSizes = (
  lists: AudienceList[] = [],
): CalculateSelectedListsSizesState => {
  const responses = useQueryListsSizes(lists);
  const isLoading = responses?.some((response) => response?.isLoading);

  const selectedListsSizesById = useMemo(() => {
    return responses.reduce((acc, response, currentIndex) => {
      const id = lists?.[currentIndex]?.id;

      return {
        ...acc,
        [id]: response,
      };
    }, {} as SelectedListsSizesById);
  }, [lists, responses, isLoading]);

  const totalRecipients = useMemo(() => {
    if (isLoading) {
      return CALCULATE_SELECTED_LISTS_SIZE_DEFAULT_STATE.totalRecipients;
    }

    return responses.reduce((acc, { size }) => {
      const listSize = size || 0;
      return acc + listSize;
    }, 0);
  }, [lists, responses, isLoading]);

  return {
    isLoading,
    totalRecipients,
    selectedListsSizesById,
  };
};
